import React from "react";
// import BaseIcon from "../../../../../components/svg_icons/BaseIcon";
// import "../../../../../css/pages/ca_pages/teams/tasks_model/TaskStatsCards.css"
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";

const TaskStatsCards = ({ stats }) => {
    const cards = [
        {
            title: "Open",
            value: stats?.open || 0,
            color: "#3b82f6",
            icon: "clipboardList",
            subText: "Needs attention",
        },

        {
            title: "In Progress",
            value: stats?.inProgress || 0,
            color: "#f59e0b",
            icon: "play",
            subText: "Currently active",
        },

        {
            title: "Completed",
            value: stats?.completed || 0,
            color: "#10b981",
            icon: "checkCircle",
            subText: "Finished successfully",
        },

        {
            title: "Overdue",
            value: stats?.overdue || 0,
            color: "#ef4444",
            icon: "circleAlert",
            subText: "Requires action",
        },

        {
            title: "Paused",
            value: stats?.paused || 0,
            color: "#8b5cf6",
            icon: "circlePause",
            subText: "Temporarily stopped",
        },
    ];

    return (
        // <div className="stats-grid">
        //     {cards.map((card) => (
        //         <div
        //             key={card.title}
        //             className="dashboard-stat-card"
        //             style={{ borderTop: `4px solid ${card.color}` }}
        //         >
        //             <div className="dashboard-stat-header">
        //                 <div
        //                     className="dashboard-stat-icon"
        //                     style={{
        //                         background: `${card.color}15`,
        //                         color: card.color,
        //                     }}
        //                 >
        //                     <BaseIcon name={card.icon} />
        //                 </div>

        //                 <span className="dashboard-stat-title">
        //                     {card.title}
        //                 </span>
        //             </div>

        //             <h2>{card.value}</h2>

        //             <p>{card.subText}</p>
        //         </div>
        //     ))}
        // </div>
        <StatsGrid cards = { cards } />
    );
};

export default TaskStatsCards;
